export default __webpack_public_path__ + "3a5177b76709819ba4663556e60222f8.svg";